import { FC, Key } from 'react';

import { useContextSelector } from 'use-context-selector';
import classNames from 'classnames';

import { Button, ButtonProps } from '../../../Button/Button';
import { FormRadioToggleContext } from '../FormRadioToggle.context';

import styles from './FormRadioToggleItem.module.scss';

interface FormRadioToggleItemProps
  extends Pick<ButtonProps, 'size' | 'children' | 'icon' | 'block'> {
  value?: Key;
  active?: boolean;
}

export const FormRadioToggleItem: FC<FormRadioToggleItemProps> = ({
  icon,
  children,
  value: localValue,
  size = 's',
  block = false,
  active = true,
}) => {
  const value = useContextSelector(
    FormRadioToggleContext,
    ({ value }) => value
  );

  const onChange = useContextSelector(
    FormRadioToggleContext,
    ({ onChange }) => onChange
  );

  const selected = localValue === value;

  return (
    <Button
      icon={icon}
      size={size}
      block={block}
      disabled={!active}
      onClick={() => onChange(localValue)}
      variant={selected ? 'primary' : 'secondary'}
      className={classNames(styles.root, {
        [styles.selected]: !selected,
        [styles.inactive]: !active,
      })}
    >
      {children}
    </Button>
  );
};
